import { buildRadioCheck, node } from "./util/dom";

interface IState {
	past: boolean;
	actual: boolean;
	future: boolean;
}

const DEFAULT_STATE = {
	past: true,
	actual: true,
	future: true,
};

class ClosureSwitch {
	_dom: {
		container: HTMLDivElement;
		[key: string]: any;
	};

	_state: IState;

	constructor() {
		this._dom = {
			container: node("div", { className: "closureswitch map-control" }),
			past: buildRadioCheck("checkbox", undefined, "minulé"),
			actual: buildRadioCheck("checkbox", undefined, "současné"),
			future: buildRadioCheck("checkbox", undefined, "budoucí"),
		};

		this.setState({});

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	setState(state: Partial<IState>) {
		this._state = {
			...DEFAULT_STATE,
			...state,
		};
	}

	getState() {
		return {
			...this._state,
		};
	}

	handleEvent() {
		this.setState({
			past: this._dom.past.input.checked,
			actual: this._dom.actual.input.checked,
			future: this._dom.future.input.checked,
		});

		Mapy.getComponent("pois").updatePoiaggOpts({
			...this.getState(),
		});
		Mapy.getComponent("pois").forceRequest(true);
	}

	_build() {
		this._dom.container.appendChild(node("span", { innerHTML: "<strong>Uzavírky</strong>" }));
		this._dom.container.append(node("span", { className: "closureswitch__separator" }));
		this._dom.container.appendChild(this._dom.past.label);
		this._dom.container.append(node("span", { className: "closureswitch__separator" }));
		this._dom.container.appendChild(this._dom.actual.label);
		this._dom.container.append(node("span", { className: "closureswitch__separator" }));
		this._dom.container.appendChild(this._dom.future.label);

		this._dom.past.input.checked = this._state.past;
		this._dom.actual.input.checked = this._state.actual;
		this._dom.future.input.checked = this._state.future;

		this._dom.past.input.addEventListener("change", this);
		this._dom.actual.input.addEventListener("change", this);
		this._dom.future.input.addEventListener("change", this);
	}
}

export default new ClosureSwitch();
